(function () {
	// Helper: select all (renamed to selectAll for clarity)
	const selectAll = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

	// Collapsible content (no jQuery) with improved accessibility and simpler listener setup
	const initCollapsibleContent = () => {
		selectAll(".collapsible-content__toggle").forEach((toggle) => {
			// Prevent duplicate listeners by using a WeakMap flag
			if (toggle.__collapsibleBound) return;
			toggle.__collapsibleBound = true;
			// Set initial aria attributes
			const parent = toggle.parentElement;
			if (parent && parent.classList.contains("active")) {
				toggle.setAttribute("aria-expanded", "true");
			} else {
				toggle.setAttribute("aria-expanded", "false");
			}
			// Ensure icon has role
			const icon = toggle.querySelector(".icon-caret");
			if (icon) icon.setAttribute("aria-hidden", "true");
			toggle.addEventListener("click", () => {
				const item = toggle.parentElement;
				const itemsWrapper = toggle.closest(".collapsible-content__items");
				if (!item) return;
				const answer = toggle.nextElementSibling;
				// Assign ID for aria-controls if missing
				if (answer && !answer.id) {
					answer.id = "collapsible-answer-" + Math.random().toString(36).slice(2, 9);
					toggle.setAttribute("aria-controls", answer.id);
				}
				const opening = !item.classList.contains("active");
				// Close others
				itemsWrapper?.querySelectorAll(".collapsible-content__item.active").forEach((el) => {
					if (el !== item) {
						el.classList.remove("active");
						const ans = el.querySelector(".collapsible-content__answer");
						if (ans) {
							ans.style.maxHeight = "0px";
							setTimeout(() => { ans.style.display = "none"; }, 300);
						}
						const tgl = el.querySelector(".collapsible-content__toggle");
						if (tgl) tgl.setAttribute("aria-expanded", "false");
					}
				});
				if (opening) {
					item.classList.add("active");
					if (answer) {
						// Expand smoothly
						answer.style.maxHeight = answer.scrollHeight + "px";
					}
					toggle.setAttribute("aria-expanded", "true");
				} else {
					item.classList.remove("active");
					if (answer) {
						answer.style.maxHeight = "0px";
					}
					toggle.setAttribute("aria-expanded", "false");
				}
			});
		});
	};

	// Slideshow logic without jQuery fadeIn/fadeOut
	const startCollapsibleSlideshow = (imageNodes) => {
		if (!imageNodes || imageNodes.length <= 1) return;
		const gallery = imageNodes[0].closest(".collapsible-content__gallery");
		const speedAttr = gallery?.getAttribute("data-speed") || "5"; // fallback 5s
		const speedMs = Number(speedAttr) * 1000;
		const fadeSpeed = 1000; // ms

		imageNodes.forEach((img, i) => {
			img.style.position = "absolute";
			img.style.top = 0;
			img.style.left = 0;
			img.style.width = "100%";
			img.style.opacity = i === 0 ? "1" : "0";
			img.style.transition = `opacity ${fadeSpeed}ms ease`;
		});
		let current = 0;
		setInterval(() => {
			const next = (current + 1) % imageNodes.length;
			imageNodes[current].style.opacity = "0";
			imageNodes[next].style.opacity = "1";
			current = next;
		}, speedMs);
	};

	const initGallery = () => {
		if (!document.querySelector(".collapsible-content")) return;
		selectAll(".collapsible-content").forEach((container) => {
			const images = selectAll(".collapsible-content__gallery--image-wrapper", container);
			if (images.length === 0) return;

			// Wrap images container to allow absolute positioning if not already
			const galleryWrapper = images[0].parentElement;
			if (galleryWrapper && !galleryWrapper.style.position) {
				galleryWrapper.style.position = "relative";
			}

			const observedTargets = container.querySelectorAll(".observe-me");
			if (observedTargets.length > 0) {
				const handleIntersect = (entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add("is-inview");
							observer.unobserve(entry.target);
							setTimeout(() => {
								entry.target.classList.remove("is-inview", "observe-me");
								startCollapsibleSlideshow(images);
							}, 600);
						}
					});
				};
				const observer = new IntersectionObserver(handleIntersect, {
					root: null,
					rootMargin: "0px",
					threshold: 0.1,
				});
				observedTargets.forEach((t) => observer.observe(t));
			} else {
				// No observer target; start immediately
				startCollapsibleSlideshow(images);
			}
		});
	};

	// Initial run (may execute before DOMContentLoaded if placed late)
	initCollapsibleContent();
	initGallery();

	document.addEventListener("DOMContentLoaded", () => {
		initCollapsibleContent();
		initGallery();
	});
	document.addEventListener("shopify:section:load", () => {
		initCollapsibleContent();
		initGallery();
	});
})();
